/** Assessment instruments. Keyed by instrument id. */
const dictionary = {
  "en": {
    "102": {
      "id": 102,
      "name": "Work Personality & Behaviour",
      "tooltip": "This assessment measures inherent strengths and limitations that come naturally to the talent. It predicts work-style preferences and provides valuable information about the professional potential of the talent. (Takes 15 min to take)"
    },
    "201": {
      "id": 201,
      "name": "Values & Motivation",
      "tooltip": "Gives insight into the talent’s professional values and motivational factors. Find out what enables professionals to perform at their best. When you and your employee share same values, you can work towards a common goal.(Takes 15 min to take)"
    },
    "301": {
      "id": 301,
      "name": "Numerical Reasoning",
      "tooltip": "Assess the ability to understand numeric data and make the right decisions based on them. (Takes 15 min to take)",
      "profileDescription": "Test your ability to understand numeric data and make the right decisions based on them. The test evaluates the ways you handle the information and you also get to know how your score ranks compared to others who carried out the test."
    },
    "302": {
      "id": 302,
      "name": "Verbal Reasoning",
      "tooltip": "Assess the ability to understand written information and to find answers to questions based on a given text. The ability to study data sets and quickly spot essential information is vital in leadership and management positions. (Takes 15 min to take)",
      "profileDescription": "Test your ability to understand and assess written information and measures your ability to find answers to questions based on a given text. The ability to study data sets and quickly spot essential information is vital in leadership and management positions."
    },
    "344": {
      "id": 344,
      "name": "Deductive Reasoning",
      "tooltip": "Measure the ability to recognize complex cause-and-effect chains and draw the correct conclusions from them. (Takes 15 min to complete)",
      "profileDescription": "Measure your ability to recognize complex cause-effect chains and draw the correct conclusions from them. "
    },
    "370": {
      "id": 370,
      "name": "English",
      "tooltip": "Measures the English language skills in fluency, vocabulary, and spelling. (Takes 15 min to complete)",
      "profileDescription": "Measure your English language skills in fluency, vocabulary, and spelling. "
    },
    "390": {
      "id": 390,
      "name": "Adept 15 Personality Assessment",
      "tooltip": "Evaluate personal characteristics, behavior tendencies, and preferences by examining 15 different dimensions of personality traits"
    }
  },
  "de": {
    "102": {
      "id": 102,
      "name": "Arbeitspersönlichkeit & Verhalten",
      "tooltip": "Dieses Assessment erfasst Stärken und Entwicklungsbereiche, die dem Talent natürlich zu eigen sind. Es sagt Arbeitsstilpräferenzen voraus und liefert wertvolle Hinweise zum beruflichen Potenzial. (Dauer: ca. 15 Minuten)"
    },
    "201": {
      "id": 201,
      "name": "Werte & Motivation",
      "tooltip": "Gibt Einblicke in die beruflichen Werte und Motivationsfaktoren des Talents. Ermitteln Sie, was eine Person zu Bestleistungen befähigt. Teilen Sie und Ihre Mitarbeitenden dieselben Werte, können Sie auf ein gemeinsames Ziel hinarbeiten. (Dauer: ca. 15 Minuten)"
    },
    "301": {
      "id": 301,
      "name": "Numerisches Denken",
      "tooltip": "Erfasst die Fähigkeit, zahlenbasierte Daten zu verstehen und darauf aufbauend die richtigen Entscheidungen zu treffen. (Dauer: ca. 15 Minuten)",
      "profileDescription": "Testen Sie Ihre Fähigkeit, zahlenbasierte Daten zu verstehen und darauf aufbauend die richtigen Entscheidungen zu treffen. Der Test bewertet, wie Sie mit numerischen Informationen umgehen; Sie erfahren außerdem, wie Ihr Ergebnis im Vergleich zu anderen Teilnehmenden abschneidet."
    },
    "302": {
      "id": 302,
      "name": "Verbales Denken",
      "tooltip": "Erfasst die Fähigkeit, schriftliche Informationen zu verstehen und anhand eines vorgegebenen Textes Fragen zu beantworten. Die Fähigkeit, Informationen zu prüfen und Wesentliches rasch zu erkennen, ist in Führungs- und Managementpositionen entscheidend. (Dauer: ca. 15 Minuten)",
      "profileDescription": "Testen Sie Ihre Fähigkeit, schriftliche Informationen zu verstehen und zu bewerten, und messen Sie, wie gut Sie anhand eines vorgegebenen Textes Antworten finden. Die Fähigkeit, Informationen zu prüfen und Wesentliches rasch zu erkennen, ist in Führungs- und Managementpositionen entscheidend."
    },
    "344": {
      "id": 344,
      "name": "Deduktives Denken",
      "tooltip": "Misst die Fähigkeit, komplexe Ursache-Wirkungs-Zusammenhänge zu erkennen und daraus die richtigen Schlüsse zu ziehen. (Dauer: ca. 15 Minuten)",
      "profileDescription": "Messen Sie Ihre Fähigkeit, komplexe Ursache-Wirkungs-Zusammenhänge zu erkennen und daraus die richtigen Schlüsse zu ziehen. "
    },
    "370": {
      "id": 370,
      "name": "Englisch",
      "tooltip": "Misst die englischen Sprachkompetenzen in Sprachflüssigkeit, Wortschatz und Rechtschreibung. (Dauer: ca. 15 Minuten)",
      "profileDescription": "Messen Sie Ihre englischen Sprachkompetenzen in Sprachflüssigkeit, Wortschatz und Rechtschreibung. "
    },
    "390": {
      "id": 390,
      "name": "Adept-15-Persönlichkeitsassessment",
      "tooltip": "Bewertet persönliche Merkmale, Verhaltenstendenzen und Präferenzen anhand von 15 Persönlichkeitsdimensionen"
    }
  },
  "fi": {
    "102": {
      "id": 102,
      "name": "Työpersoonallisuus ja käyttäytyminen",
      "tooltip": "Tämä arviointi mittaa henkilölle luonnostaan ominaisia vahvuuksia ja rajoitteita. Se ennustaa työskentelytyylejä ja antaa arvokasta tietoa henkilön ammatillisesta potentiaalista. (Kesto noin 15 min)"
    },
    "201": {
      "id": 201,
      "name": "Arvot ja motivaatio",
      "tooltip": "Antaa tietoa henkilön ammatillisista arvoista ja motivaatiotekijöistä. Selvitä, mikä auttaa ammattilaisia suoriutumaan parhaimmillaan. Kun sinulla ja työntekijälläsi on samat arvot, voitte tehdä työtä yhteisen tavoitteen eteen. (Kesto noin 15 min)"
    },
    "301": {
      "id": 301,
      "name": "Numeerinen päättely",
      "tooltip": "Arvioi kykyä ymmärtää numeerista tietoa ja tehdä sen perusteella oikeita päätöksiä. (Kesto noin 15 min)",
      "profileDescription": "Testaa kykyäsi ymmärtää numeerista tietoa ja tehdä sen perusteella oikeita päätöksiä. Testi arvioi tapaa, jolla käsittelet tietoa, ja näet myös, miten pistemääräsi sijoittuu muihin testin tehneisiin verrattuna."
    },
    "302": {
      "id": 302,
      "name": "Verbaalinen päättely",
      "tooltip": "Arvioi kykyä ymmärtää kirjallista tietoa ja löytää vastauksia kysymyksiin annetun tekstin perusteella. Kyky tutkia tietoaineistoja ja havaita nopeasti olennainen tieto on ratkaisevan tärkeää johto- ja esihenkilötehtävissä. (Kesto noin 15 min)",
      "profileDescription": "Testaa kykyäsi ymmärtää ja arvioida kirjallista tietoa sekä löytää vastauksia kysymyksiin annetun tekstin perusteella. Kyky tutkia tietoaineistoja ja havaita nopeasti olennainen tieto on ratkaisevan tärkeää johto- ja esihenkilötehtävissä."
    },
    "344": {
      "id": 344,
      "name": "Deduktiivinen päättely",
      "tooltip": "Mittaa kykyä tunnistaa monimutkaisia syy-seurausketjuja ja tehdä niistä oikeat johtopäätökset. (Kesto noin 15 min)",
      "profileDescription": "Mittaa kykyäsi tunnistaa monimutkaisia syy-seurausketjuja ja tehdä niistä oikeita johtopäätöksiä."
    },
    "370": {
      "id": 370,
      "name": "Englanti",
      "tooltip": "Mittaa englannin kielen sujuvuutta, sanastoa ja oikeinkirjoitusta. (Kesto noin 15 min)",
      "profileDescription": "Mittaa englannin kielen taitoasi: sujuvuutta, sanastoa ja oikeinkirjoitusta."
    },
    "390": {
      "id": 390,
      "name": "Adept-15-persoonallisuusarviointi",
      "tooltip": "Arvioi henkilön ominaisuuksia, käyttäytymistaipumuksia ja mieltymyksiä 15 persoonallisuusulottuvuuden avulla"
    }
  }
};

export default dictionary;
